import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface ImageEditorInterface {
  appplyActionStatus: boolean;
  fileStringDetail: FileStringDetail | null;
  fileEditedDetail: FileEditedDetail | null;
}

interface FileStringDetail {
  fromAction: string;
  fileString: string | null;
  durationSeconds?: number;
}

interface FileEditedDetail {
  fromAction: string;
  fileString: string | null;
  type: "image" | "video";
  durationSeconds?: number;
}

const initialState: ImageEditorInterface = {
  appplyActionStatus: false,
  fileStringDetail: null,
  fileEditedDetail: null,
};

const ImageEditor = createSlice({
  name: "imageeditor",
  initialState,
  reducers: {
    appplyActionImage: (state, action: PayloadAction<boolean>) => {
      state.appplyActionStatus = action.payload;
    },
    provideFileString: (
      state,
      action: PayloadAction<FileStringDetail | null>
    ) => {
      state.fileStringDetail = action.payload;
    },
    provideFileEdited: (
      state,
      action: PayloadAction<FileEditedDetail | null>
    ) => {
      state.fileEditedDetail = action.payload;
    },
  },
});

export const { provideFileString, provideFileEdited, appplyActionImage } =
  ImageEditor.actions;
export default ImageEditor.reducer;
